// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { LinkDialog } from '@/components/link-dialog';
import { AddLink } from '@/constants/hardfin-standard-icons';
import { Button, ButtonProps } from '@mui/material';
import { ReactNode, useState } from 'react';

interface Props
  extends Pick<ButtonProps, 'disabled' | 'size' | 'sx' | 'variant'> {
  /**
   * Optional button content.
   */
  children?: ReactNode;

  /**
   * A callback fired when a link is added.
   */
  onAddLink: (name: string | null, url: string) => void;
}

/**
 * A button that opens a dialog to add a link when clicked.
 */
export function LinkInputButton(props: Props) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleAddLink = (name: string | null, url: string) => {
    props.onAddLink(name, url);
  };

  return (
    <>
      <Button
        size={props.size}
        disabled={props.disabled}
        startIcon={<AddLink />}
        onClick={handleOpenDialog}
        sx={props.sx}
        variant={props.variant}
      >
        {props.children ?? 'Add a link'}
      </Button>
      <LinkDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        onAddLink={handleAddLink}
      />
    </>
  );
}
